export const formatErrorMessage = (message: string) =>
  message.replace(/\. \s*/g, '<br>');
